import { Button, Grid } from '@material-ui/core';
import React from 'react';
import { Helmet } from "react-helmet";
import logos_desktop from '../../../assets/images/circus/2025/logos_desktop.png';
import logos_mobile from '../../../assets/images/circus/2025/logos_mobile.png';
import photo1 from '../../../assets/images/circus/2025/photos/Circo2025_01.webp';
import photo2 from '../../../assets/images/circus/2025/photos/Circo2025_02.webp';
import photo3 from '../../../assets/images/circus/2025/photos/Circo2025_03.webp';
import photo4 from '../../../assets/images/circus/2025/photos/Circo2025_04.webp';
import photo5 from '../../../assets/images/circus/2025/photos/Circo2025_05.webp';
import photo6 from '../../../assets/images/circus/2025/photos/Circo2025_06.webp';
import photo7 from '../../../assets/images/circus/2025/photos/Circo2025_07.webp';
import photo8 from '../../../assets/images/circus/2025/photos/Circo2025_08.webp';
import photo9 from '../../../assets/images/circus/2025/photos/Circo2025_09.webp';
import photo10 from '../../../assets/images/circus/2025/photos/Circo2025_10.webp';
import photo11 from '../../../assets/images/circus/2025/photos/Circo2025_11.webp';
import photo12 from '../../../assets/images/circus/2025/photos/Circo2025_12.webp';
import photo13 from '../../../assets/images/circus/2025/photos/Circo2025_13.webp';
import photo14 from '../../../assets/images/circus/2025/photos/Circo2025_14.webp';
import photo15 from '../../../assets/images/circus/2025/photos/Circo2025_15.webp';
import photo16 from '../../../assets/images/circus/2025/photos/Circo2025_16.webp';
import photo17 from '../../../assets/images/circus/2025/photos/Circo2025_17.webp';
import photo18 from '../../../assets/images/circus/2025/photos/Circo2025_18.webp';
import photo19 from '../../../assets/images/circus/2025/photos/Circo2025_19.webp';
import photo20 from '../../../assets/images/circus/2025/photos/Circo2025_20.webp';
import photo21 from '../../../assets/images/circus/2025/photos/Circo2025_21.webp';
import photo22 from '../../../assets/images/circus/2025/photos/Circo2025_22.webp';
import photo23 from '../../../assets/images/circus/2025/photos/Circo2025_23.webp';
import photo24 from '../../../assets/images/circus/2025/photos/Circo2025_24.webp';
import photo25 from '../../../assets/images/circus/2025/photos/Circo2025_25.webp';
import { useGtXs } from '../../../hooks/useGtXs';
import { Config } from '../../../services/Config';
import EventGallery from '../../EventGallery/EventGallery';
import PageTransition from '../../PageTransition/PageTransition';
import Typography from '../../Typography/Typography';
import styles from './Circus2025View.module.scss';
import useGetCircus2025Sessions from './Helpers/useGetCircus2025Sessions';
import Separator from './Separator';
import Session from './Session';

const photos = [
    photo1,
    photo2,
    photo3,
    photo4,
    photo5,
    photo6,
    photo7,
    photo8,
    photo9,
    photo10,
    photo11,
    photo12,
    photo13,
    photo14,
    photo15,
    photo16,
    photo17,
    photo18,
    photo19,
    photo20,
    photo21,
    photo22,
    photo23,
    photo24,
    photo25,
]

const artists = [
    { id: 1, discipline: "CLOUDSWING", artists: ["Kyle Fowler"] },
    { id: 2, discipline: "ESPIRAL AÉREA", artists: ["Martina Machluk"] },
    { id: 3, discipline: "MANIPULAÇÃO DE CUBO", artists: ["Marcin Janiak"] },
    { id: 4, discipline: "RODA CYR", artists: ["Carolin Liesegang"] },
    { id: 5, discipline: "CONTORCIONISMO E FORÇAS COMBINADAS", artists: ["Angara Contortion Group"] },
    { id: 6, discipline: "BARRA RUSSA", artists: ["Pushing Forte"] },
    { id: 7, discipline: "PALHAÇOS", artists: ["Adolfo Luftman", "e Arys Ribeiro"] },
    { id: 8, discipline: "TECIDOS", artists: ["Małgorzata Krzciuk-Freitas", "e Marta Kowalewska"] },
]

const Artist = (props: any) => {
    const { artist } = props

    const gtXs = useGtXs()
    const disciplineVariant = gtXs ? "RocGroteskRegular25" : "RocGroteskRegular16"
    const nameVariant = gtXs ? "RocGroteskBold30" : "RocGroteskBold20"

    return (
        <Grid item xs={12} md={6} container className={styles.Artist}>
            <Grid container className={styles.ArtistWrapper} justify="center">
                <div>
                    <Typography variant={disciplineVariant} component="p">
                        {artist.discipline}
                    </Typography>
                    <div className={styles.ArtistName}>
                        {artist.artists.map((name: string) =>
                            <Typography variant={nameVariant} component="p">
                                {name}
                            </Typography>
                        )}
                    </div>
                </div>
            </Grid>
        </Grid>
    )
}


export default function Circus2025View() {

    const { decemberSessions, januarySessions } = useGetCircus2025Sessions()
    const gtXs = useGtXs()
    const handle = () => {
        window.open("https://coliseu.pt/agenda")
    }

    return (
        <PageTransition>
            <>
                <Helmet>
                    <meta property="og:site_name" content="Coliseu Porto Ageas" />
                    <meta property="og:url" content={`${Config.APP}circo-2025`} />
                    <meta property="og:type" content="article" />
                    <meta property="og:title" content="Coliseu Porto Ageas" />
                    <meta property="og:description" content="De 13 de dezembro a 5 de janeiro, o Coliseu Porto Ageas apresenta um espetáculo memorável." />
                </Helmet>


                <div className={styles.Hero} />

                <Grid container justify="center" className={styles.Wrapper}>

                    <div className={styles.Circus2025}>

                        <section className={styles.Intro}>

                            <p>
                                <b>De 12 de dezembro a 4 de janeiro, artistas de todo o mundo</b> mostram no Circo de Natal do Coliseu o que as artes circenses têm de mais fantástico! Com história
                                original escrita por Marta Pais Oliveira e música original de Bruno Pernadas, convidamos miúdos e graúdos para um espetáculo único, irrepetível e surpreendente.
                            </p>

                            <p>
                                A vencedora do Prémio Revelação Agustina Bessa-Luís escreveu uma história centrada na figura mítica do Apresentador de Circo. O público vai poder conhecer Cícero,
                                a voz que antecipa ao público cada número e que guia as emoções dos espectadores com brilho e humor, aqui acompanhado por outra personagem central desta história,
                                a sua Mãe.
                            </p>

                            <Grid container className={styles.Credits}>
                                <Grid item xs={12}>
                                    <div>
                                        <h5>HISTÓRIA “CÍCERO E O MILAGRE DA VIDA”</h5>
                                        <p><b>Marta Pais Oliveira</b></p>
                                    </div>
                                    <div>
                                        <h5>MÚSICA</h5>
                                        <p><b>Bruno Pernadas</b></p>
                                    </div>
                                    <div>
                                        <h5>FIGURINOS</h5>
                                        <p><b>Berta Cardoso</b></p>
                                    </div>
                                    <div>
                                        <h5>MESTRES DE CERIMÓNIA</h5>
                                        <p><b>Diana Sá e Emílio Gomes</b></p>
                                    </div>

                                </Grid>
                            </Grid>
                        </section>



                        <section className={styles.Sessions}>

                            <Separator title="SESSÕES" />

                            <Grid container justify="center" className={styles.SessionMonth}>
                                <Typography variant="RocGroteskRegular20">
                                    DEZEMBRO
                                </Typography>
                            </Grid>

                            <Grid container spacing={2} className={styles.SessionGrid}>
                                {decemberSessions.map(session =>
                                    <Session session={session} key={session.id} />
                                )}
                            </Grid>

                            <Grid container justify="center" className={styles.SessionMonth}>
                                <Typography variant="RocGroteskRegular20">
                                    JANEIRO
                                </Typography>
                            </Grid>

                            <Grid container spacing={2} className={styles.SessionGrid}>
                                {januarySessions.map(session =>
                                    <Session session={session} key={session.id} />
                                )}
                            </Grid>

                            <p style={{ paddingTop: 30 }}>Bilhetes entre 10€ e 20€, à venda no Coliseu, Ticketline e locais habituais.</p>

                            <div className={styles.Discounts}>
                                <p>Descontos</p>
                                <p>75% crianças até aos 3 anos</p>
                                <p>50% crianças até aos 12 anos</p>
                                <p>20% Amigos do Coliseu e Cartão Porto</p>
                            </div>


                            <Grid container justify="center" className={styles.Call2Action}>
                                <Button onClick={handle} variant="outlined">
                                    Agenda Coliseu
                                </Button>
                            </Grid>

                        </section>

                        <section className={styles.Artists}>

                            <Separator title="ARTISTAS" />

                            <Grid container className={styles.ArtistsContainer}>
                                {artists.map(artist =>
                                    <Artist artist={artist} key={artist.id} />
                                )}
                            </Grid>

                        </section>

                        <section className={styles.Gallery}>

                            <Separator title="GALERIA" />

                            <Grid container direction="row" justify="center">
                                <Grid item xs={12} lg={10}>
                                    <EventGallery photos={photos} hideTitle />
                                </Grid>
                            </Grid>
                        </section>

                        <section className={styles.Staff}>

                            <Separator title="FICHA TÉCNICA" />

                            <Grid container className={styles.TechTeam}>
                                <Grid item xs={12} md={6}>
                                    <div>
                                        <p><b>HISTÓRIA</b> Marta Pais Oliveira</p>
                                        <p><b>MÚSICA</b> Bruno Pernadas</p>
                                        <p><b>FIGURINOS</b> Berta Cardoso</p>
                                        <p><b>DIREÇÃO DE PRODUÇÃO</b> Graça Barreto</p>
                                        <p><b>PRODUÇÃO</b> Juliana Agostinho e Luísa Teixeira</p>
                                        <p><b>DIREÇÃO TÉCNICA</b> Joaquim Madaíl</p>
                                        <p><b>DESENHO DE LUZ</b> Tiago Mota</p>
                                        <p><b>DESENHO DE SOM</b> António Abreu</p>
                                        <p><b>OPERAÇÃO DE LUZ</b> Paulo Marinho e Tiago Mota</p>
                                        <p><b>OPERAÇÃO DE SOM</b> António Abreu e Helena Antunes</p>
                                        <p><b>OPERAÇÃO DE MAQUINARIA</b> Artem Yakunim e João Pereira</p>
                                        <p><b>ASSISTENTE DE MAQUINARIA</b> Fernando Mota</p>
                                        <p><b>OPERAÇÃO DE FOLLOWSPOT</b> Antonio Mota e Eduardo Alves</p>
                                        <p><b>ELETRICISTA</b> Artem Yakunim</p>
                                        <p><b>ASSISTENTES DE PALCO</b> Bruno Gomes, João Bragança, Miguel Guedes e Zé Kalanga Rigging Artur Bastos e Audioglobo</p>
                                        <p><b>APOIO MONTAGENS</b> Stay on The Scene</p>
                                    </div>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <div>
                                        <p><b>MESTRES DE CERIMÓNIA</b><br /> Diana Sá e Emílio Gomes</p>
                                        <p><b>MANIPULAÇÃO DE CUBO</b><br /> Marcin Janiak</p>
                                        <p><b>ESPIRAL AÉREA</b><br /> Martina Machluk</p>
                                        <p><b>PALHAÇOS</b><br /> Adolfo Luftman e Arys Ribeiro</p>
                                        <p><b>CONTORCIONISMO E FORÇAS COMBINADAS</b><br /> Shinetsetseg Bayartsetseg, Shurentsetseg Badamdorj e Serchmaa Bayarsaikhan</p>
                                        <p><b>CLOUDSWING</b><br /> Kyle Fowler</p>
                                        <p><b>RODA CYR</b><br /> Carolin Liesegang</p>
                                        <p><b>BARRA RUSSA</b><br /> Coen Clarke, Niko Miettinen e Richard Fox</p>
                                        <p><b>TECIDOS</b><br /> Małgorzata Krzciuk-Freitas e Marta Kowalewska</p>
                                    </div>
                                </Grid>
                            </Grid>

                            <div className={styles.Coordination}>
                                <p><b>COORDENAÇÃO GERAL:</b> Miguel Guedes</p>
                            </div>

                            <div className={styles.Team}>
                                <p>
                                    <b>Equipa Coliseu:</b> António Abreu, Artem Yakunin, Bruna Santos, Celestino Teixeira, Diana Fernandes, Eduardo Amorim Cambra, Eduardo Cambra, Fernando Mota, Filipa Godinho, Fátima Pinto, Graça Barreto, Joaquim Madaíl, José Carlos Pinto Coelho, João Couto, João Pereira, João Puig, João Rosário, Juliana Agostinho, Justina Vilela, Leandro Couto, Luís Barros, Luísa Teixeira, Manuel Lopes, Paulo Alves, Paulo Marinho, Sara Coelho, Tiago Azevedo, Tiago Mota, Tânia Ferreira
                                </p>

                            </div>

                        </section>

                        <section className={styles.Footer}>
                            <Grid container justify="center">
                                <img src={gtXs ? logos_desktop : logos_mobile} alt="logotipos apoios" />
                            </Grid>
                        </section>
                    </div>
                </Grid>
            </>
        </PageTransition >
    )
}
